import {css, cx} from "@panda/css";

import {CloseIcon, type IIcon} from "@pg-design/icons";

interface Props {
    onClose: () => void;
    className?: string;
    "data-testid"?: string;
    iconSize?: IIcon["size"];
}

export const CloseButton = (props: Props) => {
    const {onClose, className, "data-testid": dataTestId, iconSize = "1.6"} = props;

    return (
        <div className={cx(closeButtonStyle, className)} onClick={onClose} data-testid={dataTestId}>
            <CloseIcon size={iconSize} fill="var(--colors-secondary)" />
        </div>
    );
};

const closeButtonStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    background: "var(--colors-white)",
    boxShadow: "var(--shadows-3)",
    cursor: "pointer",
    width: "3.2rem",
    height: "3.2rem"
});
import {css, cx} from "@panda/css";

import {CloseIcon, type IIcon} from "@pg-design/icons";

interface Props {
    onClose: () => void;
    className?: string;
    "data-testid"?: string;
    iconSize?: IIcon["size"];
}

export const CloseButton = (props: Props) => {
    const {onClose, className, "data-testid": dataTestId, iconSize = "1.6"} = props;

    return (
        <div className={cx(closeButtonStyle, className)} onClick={onClose} data-testid={dataTestId}>
            <CloseIcon size={iconSize} fill="var(--colors-secondary)" />
        </div>
    );
};

const closeButtonStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    background: "var(--colors-white)",
    boxShadow: "var(--shadows-3)",
    cursor: "pointer",
    width: "3.2rem",
    height: "3.2rem"
});
